import { PopoverAnchorDirective } from '@progress/kendo-angular-tooltip';

const showPopupTimout = (element: PopoverAnchorDirective, timeout: number) => {
  return setTimeout(() => {
    element.show();
  }, timeout) as unknown as number;
};

const stopOrRemovePopup = (element: PopoverAnchorDirective, timeout: number) => {
  clearTimeout(timeout);
  element.hide();
};

export { showPopupTimout, stopOrRemovePopup };
